import { IVideosAssignmentContext } from './videosAssignmentContext';

export enum VideosAssignmentActionTypes {
	SET_VIDEOS_FOR_ASSIGN = 'SET_VIDEOS_FOR_ASSIGN',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS = 'CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS',
	CHANGE_SEARCH_STRING_FOR_RESTAURANTS = 'CHANGE_SEARCH_STRING_FOR_RESTAURANTS',
	CHANGE_SEARCH_STRING_FOR_VIDEOS = 'CHANGE_SEARCH_STRING_FOR_VIDEOS',
	SET_STUDIO = 'SET_STUDIO',
	SET_CATEGORY = 'SET_CATEGORY',
	TOGGLE_UNASSIGNED_VIDEOS = 'TOGGLE_UNASSIGNED_VIDEOS',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_IDS_SELECTED_VIDEOS = 'SET_IDS_SELECTED_VIDEOS',
	CHANGE_ACTIVE_ITEM_TO_DISPLAY = 'CHANGE_ACTIVE_ITEM_TO_DISPLAY',
	SET_SHOW_BREADCRUMBS = 'SET_SHOW_BREADCRUMBS',
	SET_ALL_CUSTOMERS = 'SET_ALL_CUSTOMERS',
	SET_IDS_SELECTED_CUSTOMERS = 'SET_IDS_SELECTED_CUSTOMERS',
	SET_IDS_SELECTED_RESTAURANTS = 'SET_IDS_SELECTED_RESTAURANTS',
	SET_VIDEOS = 'SET_VIDEOS',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	RESET_CHANGES = 'RESET_CHANGES',
}

interface ISetVideosForAssign {
	type: VideosAssignmentActionTypes.SET_VIDEOS_FOR_ASSIGN;
	payload: {
		videosForAssign: IVideosAssignmentContext['videosForAssign'];
	};
}

interface IChangeSearchString {
	type: VideosAssignmentActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IVideosAssignmentContext['searchString'];
	};
}

interface IChangeSearchStringForAllCustomers {
	type: VideosAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS;
	payload: {
		searchStringForAllCustomers: IVideosAssignmentContext['searchStringForAllCustomers'];
	};
}

interface IChangeSearchStringForRestaurants {
	type: VideosAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_RESTAURANTS;
	payload: {
		searchStringForRestaurants: IVideosAssignmentContext['searchStringForRestaurants'];
	};
}

interface IChangeSearchStringForVideos {
	type: VideosAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_VIDEOS;
	payload: {
		searchStringForVideos: IVideosAssignmentContext['searchStringForVideos'];
	};
}

interface ISetStudio {
	type: VideosAssignmentActionTypes.SET_STUDIO;
	payload: {
		selectedStudio: IVideosAssignmentContext['selectedStudio'];
	};
}

interface ISetCategory {
	type: VideosAssignmentActionTypes.SET_CATEGORY;
	payload: {
		selectedCategory: IVideosAssignmentContext['selectedCategory'];
	};
}

interface IToggleUnassignedVideos {
	type: VideosAssignmentActionTypes.TOGGLE_UNASSIGNED_VIDEOS;
}

interface IResetSelectedControls {
	type: VideosAssignmentActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: VideosAssignmentActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IVideosAssignmentContext['sortBy'];
	};
}

interface ISetIDsSelectedVideos {
	type: VideosAssignmentActionTypes.SET_IDS_SELECTED_VIDEOS;
	payload: {
		IDsSelectedVideos: IVideosAssignmentContext['IDsSelectedVideos'];
	};
}

interface IChangeActiveItemToDisplay {
	type: VideosAssignmentActionTypes.CHANGE_ACTIVE_ITEM_TO_DISPLAY;
	payload: {
		activeItemToDisplay: IVideosAssignmentContext['activeItemToDisplay'];
	};
}

interface ISetShowBreadcrumbs {
	type: VideosAssignmentActionTypes.SET_SHOW_BREADCRUMBS;
	payload: {
		isShowBreadcrumbs: IVideosAssignmentContext['isShowBreadcrumbs'];
	};
}

interface ISetAllCustomers {
	type: VideosAssignmentActionTypes.SET_ALL_CUSTOMERS;
	payload: {
		allCustomers: IVideosAssignmentContext['allCustomers'];
	};
}

interface ISetIDsSelectedCustomers {
	type: VideosAssignmentActionTypes.SET_IDS_SELECTED_CUSTOMERS;
	payload: {
		IDsSelectedCustomers: IVideosAssignmentContext['IDsSelectedCustomers'];
		restaurants: IVideosAssignmentContext['restaurants'];
		IDsSelectedRestaurants: IVideosAssignmentContext['IDsSelectedRestaurants'];
		videos: IVideosAssignmentContext['videos'];
	};
}

interface ISetIDsSelectedRestaurants {
	type: VideosAssignmentActionTypes.SET_IDS_SELECTED_RESTAURANTS;
	payload: {
		IDsSelectedRestaurants: IVideosAssignmentContext['IDsSelectedRestaurants'];
		videos: IVideosAssignmentContext['videos'];
	};
}

interface ISetVideos {
	type: VideosAssignmentActionTypes.SET_VIDEOS;
	payload: {
		videos: IVideosAssignmentContext['videos'];
		IDsSelectedVideos: IVideosAssignmentContext['IDsSelectedVideos'];
	};
}

interface IChangeTypeOfModalWindow {
	type: VideosAssignmentActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IVideosAssignmentContext['typeOfModalWindow'];
	};
}

interface IChangeCurrentPage {
	type: VideosAssignmentActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IVideosAssignmentContext['currentPage'];
	};
}

interface IResetChanges {
	type: VideosAssignmentActionTypes.RESET_CHANGES;
}

export type TVideosAssignmentAction =
	| ISetVideosForAssign
	| IChangeSearchString
	| IChangeSearchStringForAllCustomers
	| IChangeSearchStringForRestaurants
	| IChangeSearchStringForVideos
	| ISetStudio
	| ISetCategory
	| IToggleUnassignedVideos
	| IResetSelectedControls
	| ISetSortBy
	| ISetIDsSelectedVideos
	| IChangeActiveItemToDisplay
	| ISetShowBreadcrumbs
	| ISetAllCustomers
	| ISetIDsSelectedCustomers
	| ISetIDsSelectedRestaurants
	| ISetVideos
	| IChangeTypeOfModalWindow
	| IChangeCurrentPage
	| IResetChanges;
